/**
 * Explicit colors for the three override kinds (Link/Mark shared/Mark external), used wherever a
 * license needs to visually read as "attributed" — badges, per-cell icons, dialog notes. Fluent's
 * semantic Badge colors don't give three visually distinct hues here: 'brand' and 'informative'
 * both render as blue in this theme (confirmed against Dashboard.tsx's own ATTRIBUTION_COLOR-style
 * override for alert severity), so these pull explicit palette tokens instead of relying on
 * Lozenge's named `color` prop for External.
 */
import { tokens } from '@fluentui/react-components'
import type { ResolutionKind } from '../types'

export const ATTRIBUTION_COLOR: Partial<Record<ResolutionKind, string>> = {
  manual: tokens.colorBrandForeground1,
  shared: tokens.colorPaletteMarigoldForeground1,
  external: tokens.colorPaletteTealForeground2,
}

export const EXTERNAL_BADGE_STYLE = {
  color: tokens.colorPaletteTealForeground2,
  borderColor: tokens.colorPaletteTealBorderActive,
}
